export const branch = {
  HEADOFFICE: 'Head Office',
  REGION02: 'Region 2',
  REGION05: 'REGION05',
  REGION01: 'REGION01',
  REGION03: 'REGION03',
  SUTERAMALL: 'SUTERAMALL',
  TAMPOI: 'TAMPOI',
  PELANGI: 'PELANGI',
  setiatro: 'setiatro',
  AMINAH: 'AMINAH',
  TEBRAU: 'TEBRAU',
  SHELL: 'SHELL',
  RINTING: 'RINTING',
  GAYA: 'GAYA',
  SURIA: 'SURIA',
  SENTOSA: 'SENTOSA',
  molek: 'molek',
  PGUDANG: 'PGUDANG',
  MELAKA: 'MELAKA',
}
